// DS: i3.4
import React from 'react';
import IconWrap from '../IconWrap';
const ArrowRight = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.225 20.427a1 1 0 01-1.414-1.414l7.07-7.071-7.07-7.071a1 1 0 011.414-1.414l7.778 7.778a1 1 0 010 1.414l-7.778 7.778z",
        clipRule: "evenodd"
    })));
ArrowRight.displayName = 'ArrowRight';
export default ArrowRight;
